import React from 'react';
import { NavLink } from 'react-router-dom';
import { UserOutlined, LockOutlined, TeamOutlined, SafetyOutlined, KeyOutlined, CreditCardOutlined } from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';

const SettingsSidebar: React.FC = () => {
  const { user } = useAuth();
  
  const userInitial = user?.name?.charAt(0).toUpperCase() || user?.email?.charAt(0).toUpperCase() || 'U';

  return (
    <div className="space-y-8">
      <div className="flex items-center gap-4">
        <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center text-white font-bold text-2xl flex-shrink-0">
          {userInitial}
        </div>
        <div>
          <h2 className="text-lg font-bold text-gray-800 dark:text-gray-200">{user?.name || 'User'}</h2>
          <p className="text-xs text-gray-500">{user?.email || ''}</p>
        </div>
      </div>

      <nav className="space-y-1">
        {[
          { to: '/settings', icon: <UserOutlined />, label: 'User Information', end: true },
          { to: '/settings/billing', icon: <CreditCardOutlined />, label: 'Billing & Usage', end: false },
        ].map(({ to, icon, label, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              `w-full flex items-center gap-4 px-4 py-3 text-left transition-all rounded-full ${
                isActive
                  ? 'bg-white dark:bg-gray-800 shadow-sm border-l-4 border-black dark:border-white text-gray-800 dark:text-gray-200 font-bold'
                  : 'hover:bg-white dark:hover:bg-gray-800 hover:shadow-sm text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200'
              }`
            }
          >
            <span className="text-lg">{icon}</span>
            <span className="text-sm flex-1">{label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="px-4 text-xs text-gray-500 leading-relaxed space-y-3">
        <p>
          Manage your account settings, security preferences, and billing information.
        </p>
      </div>
    </div>
  );
};

export default SettingsSidebar;